// Money formatting for the whole portal: "$1,234.50". Kept free of the Supabase
// client so presentational components can use it.
export const formatCurrency = (amount, currency = 'AUD') =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format(amount);
